/* eslint-disable no-useless-escape */
import * as Yup from "yup";

export const LoginEmailValidationSchema = Yup.object({
  email: Yup.string().email("Please enter valid email").required(),
  password: Yup.string()
    .min(6, "Please enter 6 characters")
    .required("Password is required"),
});

export const lexitasStyleValidationSchema = Yup.object({
  excelFile: Yup.string().required("Excel file is required"),
});
